import type { ReactNode } from "react";
import type { Stage } from "@/types/journey";
import { BoatScene } from "@/components/BoatScene";
import { SoundToggle } from "@/components/SoundToggle";

interface Props {
  stage: Stage;
  progress: 0 | 1 | 2 | 3 | 4;
  soundEnabled: boolean;
  onSoundChange: (value: boolean) => void;
  onRestart: () => void;
  children: ReactNode;
  className?: string;
}

export function ScreenFrame({ stage, progress, soundEnabled, onSoundChange, onRestart, children, className = "" }: Props) {
  return (
    <div className={`app-frame ${className}`}>
      <header className="topbar">
        <button className="brand-lockup" type="button" onClick={onRestart} aria-label="回到红船三问首页">
          <span className="brand-seal">三<br />问</span>
          <span><strong>红船三问</strong><small>AI时代的青年答案</small></span>
        </button>
        <div className="topbar-actions">
          <SoundToggle enabled={soundEnabled} onChange={onSoundChange} />
          <button className="restart-button" type="button" onClick={onRestart}>重新开始</button>
        </div>
      </header>
      <div className="experience-layout">
        <aside className="scene-column">
          <div className="scene-wrap"><BoatScene progress={progress} stage={stage} /></div>
          <div className="scene-column-note"><span>南湖 · 2026</span><strong>一条船，正在把问题带向下一步。</strong></div>
        </aside>
        <main className="main-content">{children}</main>
      </div>
      <footer className="page-footer">
        <span>红船三问 / 2026</span>
        <span>一个问题 · 三次选择 · 一步行动</span>
      </footer>
    </div>
  );
}
